import { useAppDispatch } from "../store/hooks"
import { updateCartItem } from "../store/slices/cartSlice"
import { addToWishlist, removeFromWishlist } from "../store/slices/wishlistSlice"

export const useProductActions = () => {
  const dispatch = useAppDispatch()

  const addToCart = (productId, quantity = 1, redirectToCart = false) => {
    return dispatch(
      updateCartItem({
        productId,
        quantity,
        type: "add",
        redirectToCart,
      }),
    )
  }

  const updateCartQuantity = (productId, quantity) => {
    return dispatch(
      updateCartItem({
        productId,
        quantity,
        type: "update",
      }),
    )
  }

  const removeFromCart = (productId) => {
    return dispatch(
      updateCartItem({
        productId,
        quantity: 0,
        type: "update",
      }),
    )
  }

  const toggleWishlist = (productId, isInWishlist) => {
    if (isInWishlist) {
      return dispatch(removeFromWishlist(productId))
    } else {
      return dispatch(addToWishlist(productId))
    }
  }

  const moveToWishlist = (productId) => {
    dispatch(addToWishlist(productId))
    return dispatch(
      updateCartItem({
        productId,
        quantity: 0,
        type: "update",
      }),
    )
  }

  const moveToCart = (productId, quantity = 1) => {
    dispatch(removeFromWishlist(productId))
    return dispatch(
      updateCartItem({
        productId,
        quantity,
        type: "add",
      }),
    )
  }

  return {
    addToCart,
    updateCartQuantity,
    removeFromCart,
    toggleWishlist,
    moveToWishlist,
    moveToCart,
  }
}
